import { RiskProfileStatsGrid } from '../../RiskProfileStatsGrid'
import { useProfileElementGroupData } from '../../../hooks/useProfileElementGroupData'
import { useProfileHazardTypeData } from '../../../hooks/useProfileHazardTypeData'
import type { RiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'

interface GroupStatsSectionProps {
  queryParams: RiskProfileQueryParams | null
  metricOption: RiskProfileMetricOption
}

export function GroupStatsSection({ queryParams, metricOption }: GroupStatsSectionProps) {
  const { query: elementGroupQuery } = useProfileElementGroupData(queryParams)
  const { query: hazardQuery } = useProfileHazardTypeData(queryParams)

  return (
    <RiskProfileStatsGrid
      elementData={elementGroupQuery.data}
      hazardData={hazardQuery.data}
      metricOption={metricOption}
      isLoading={elementGroupQuery.status === 'pending' || hazardQuery.status === 'pending'}
    />
  )
}
